import { marked } from "marked";
import { useEffect, useRef, useState } from "react";

interface Props {
  text: string;
  msPerCharacter: number;
  onTypingFinish?: () => void;
}

export const useTypingEffect = ({ text, msPerCharacter, onTypingFinish }: Props) => {
  const [textPosition, setTextPosition] = useState<number>(0);
  const textPositionRef = useRef(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTextPosition((value) => value + 1);
      textPositionRef.current += 1;
      if (textPositionRef.current > text.length - 1) {
        clearInterval(intervalId);
        onTypingFinish?.();
      }
    }, msPerCharacter);
    return () => {
      clearInterval(intervalId);
    };
  }, [msPerCharacter, text]);

  return text.substring(0, textPosition);
};

const TypingAnimation = ({ text, msPerCharacter, onTypingFinish }: Props) => {
  const displayedText = useTypingEffect({
    text,
    msPerCharacter,
    onTypingFinish,
  });

  return <span key={`${text}-${displayedText.length}`} dangerouslySetInnerHTML={{ __html: marked.parse(displayedText) }} />;
};

export default TypingAnimation;
